<div
  class="number-stats"
  [class.summary-mode]="isSummaryStatsLayout"
  [style.--dvm-number-stats-font-size]="resolvedFontSize || null"
  [style.--dvm-number-stats-value-font-scale]="resolvedValueFontScale || null"
  [style.--dvm-number-stats-card-height]="resolvedCardHeight || null">
  <div class="card stat-card">
    <div *ngIf="isSummaryStatsLayout; else defaultStatsLayout" class="summary-stat-content">
      <div class="summary-stat-title" [style.font-size]="summaryTitleFontSize || null" [innerHTML]="formattedTitle"></div>

      <div class="summary-stat-value-or-error">
        <ng-container *ngIf="!hasError">
          <div *ngIf="summarySections.length; else summarySingleValue" class="summary-stat-sections">
            <div
              *ngFor="let section of summarySections; let last = last"
              class="summary-stat-section"
              [class.has-divider]="!last">
              <div class="summary-stat-section-label" [style.font-size]="section.labelFontSize || summaryLabelFontSize || null">
                {{ section.label }}
              </div>
              <div
                class="summary-stat-section-value"
                [style.color]="section.color || summaryValueColor || null"
                [style.font-size]="section.fontSize || summaryValueFontSize || null">
                {{ section.value }}
              </div>
            </div>
          </div>

          <ng-template #summarySingleValue>
            <div
              class="summary-stat-primary-value"
              [style.color]="summaryValueColor || null"
              [style.font-size]="summaryValueFontSize || null">
              {{ stat }}
            </div>
          </ng-template>
        </ng-container>
        <mat-icon *ngIf="shouldShowErrorIcon" class="stat-error-icon">error_outline</mat-icon>
      </div>
    </div>

    <ng-template #defaultStatsLayout>
    <div class="card-content" [ngClass]="alignmentClass">
      <div class="card-title" [innerHTML]="formattedTitle"></div>
      <div class="card-value-or-error">
        <ng-container *ngIf="!hasError">
          <input
            *ngIf="isEditableNumberStat; else readonlyStat"
            class="card-value card-value-input"
            type="text"
            [ngModel]="statInputValue"
            (ngModelChange)="onStatInputChange($event)"
            (keyup.enter)="onInputStatEnter()"
          />
          <ng-template #readonlyStat>
            <div class="card-value" [style.font-size]="resolvedValueFontSize || null">{{ stat }}</div>
          </ng-template>
        </ng-container>
        <mat-icon *ngIf="shouldShowErrorIcon" class="stat-error-icon">error_outline</mat-icon>
      </div>
    </div>
    </ng-template>
  </div>
</div>
